import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { RouterState, goBack, push } from 'redux-first-history';
import { isEmpty } from 'lodash-es';
import { TFunction, withTranslation } from 'react-i18next';

import Auth from '@/services/Authentication';
// import Loader from '@/services/PageLoader';
import { ApplicationState as State } from '@/store';
import { LocationHistoryState } from '@/store/locationHistory/types';
import { ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { CampaignsPaths } from '@/services/dictionaries/Paths';

import LayoutSrc from './layout.html';

interface LegacyDashRouteType {
    router: RouterState;
    locationHistory: LocationHistoryState;
    bootedAsChild: boolean;
    t?: TFunction;
}

type LegacyDashRouteStateType = {
    isLoading: boolean;
    disableRedirect: boolean;
};
const dispatchProps = {
    ShowDialog,
    push,
    goBack,
};
interface DispatchProps {
    ShowDialog(params: ShowDialogParams): void;
    goBack(): void;
    push(url: string): void;
}

type ExtendedProps = LegacyDashRouteType & DispatchProps;

const CDN_PATH = LEGACY_EE_BUNDLE;

const mapState = (state: State): LegacyDashRouteType => ({
    router: state.router,
    locationHistory: state.locationHistory,
    bootedAsChild: state.config.bootedAsChild,
});

class LegacyDashRoute extends Component<ExtendedProps, LegacyDashRouteStateType> {
    public constructor(props) {
        super(props);

        const bundlePath = `${CDN_PATH}/1.0/emailinterface.js`;
        const cssPath = `${CDN_PATH}/1.0/emailinterface.css"`;
        const apiPath = `${APIPATH}`;
        this.template = this.template.replace('{{BUNDLE_PATH}}', bundlePath);
        this.template = this.template.replace('{{CSS_PATH}}', cssPath);
        this.template = this.template.replace('{{apiPath}}', apiPath);
        this.template = this.template.replace("'{{bootedAsChild}}'", this.props.bootedAsChild as any);

        this.state = {
            isLoading: true,
            disableRedirect: true,
        };

        if (props?.locationHistory?.previousLocation?.pathname) {
            sessionStorage.setItem(
                'prevPath',
                `${props.locationHistory.previousLocation.pathname}${props.locationHistory.previousLocation.search}`
            );
        }
        window.document.addEventListener('navigateBack', this.navigateBack);
    }

    private preventExitingCampaignCreator(e: any) {
        const { t } = this.props;
        const isCampaignScreen = window?.location?.href?.includes(CampaignsPaths.CampaignCreator);
        if (this.state.disableRedirect && isCampaignScreen) {
            // @ts-expect-error ee global object
            const shouldPreventExiting = this.iFrameRef.current?.contentWindow?.window?.ee?.view?.isDirty;
            if (shouldPreventExiting) {
                e.preventDefault();
                e.stopPropagation();
                return this.props.ShowDialog({
                    title: t('information'),
                    body: t('exitwithoutsaving'),
                    confirmLabel: t('yes'),
                    cancelLabel: t('cancel'),
                    onClickConfirm: () => this.continueMenuButtonClick(e.target),
                });
            }
        }
    }

    private continueMenuButtonClick(target) {
        this.setState({ disableRedirect: false }, () => {
            const clickEvent = new Event('click', { bubbles: true });
            target.dispatchEvent(clickEvent);
        });
        return null;
    }

    private iFrameRef = createRef<HTMLIFrameElement>();

    private timeoutId: any;

    private template = LayoutSrc;

    public componentDidUpdate(prevProps: any): void {
        if (prevProps.router.location.hash !== (this.props.router.location as any)?.hash) {
            // @ts-expect-error ee global object
            this.iFrameRef.current?.contentWindow?.window?.ee?.goTo?.(this.props.router.location.hash);
        }

        if (LEGACYDASHFROMLOCAL) {
            console.warn(
                'You have set LEGACYDASHFROMLOCAL in .env file, it will serve legacy dashboard from "/deploy/1.0/" files in your local machine. if you want to see any changes in legacy dashboard files you have to run "npm run build" or "npm run build-prod" after each change. Please note you can run it in seperate process and you DONT have to stop "run next-gen bundle" process'
            );
        }
    }

    public componentDidMount(): void {
        this.isLegacyDashLoaded();
    }

    private isLegacyDashLoaded(): void {
        this.timeoutId = setTimeout(() => {
            sessionStorage.setItem('key', Auth.getAccessToken());
            const iFrameWindow = this.iFrameRef?.current?.contentWindow?.window;

            // @ts-expect-error ee global object
            if (iFrameWindow.ee && !isEmpty(iFrameWindow.ee.data) && !isEmpty(iFrameWindow.ee.data.account)) {
                clearTimeout(this.timeoutId);
                // @ts-expect-error ee global object
                iFrameWindow.ee.indiOn();
                setTimeout(() => {
                    // @ts-expect-error ee global object
                    iFrameWindow.ee.indiOff();
                }, 2000);

                this.setState({ isLoading: false });

                this.menuList?.addEventListener('click', this.preventExitingCampaignCreator.bind(this));
                return;
            }

            this.isLegacyDashLoaded();
        }, 100);
    }

    private menuList = document.getElementsByClassName('menuItems')?.[0];

    public componentWillUnmount(): void {
        this.menuList?.removeEventListener?.('click', this.preventExitingCampaignCreator.bind(this));
        window.document.removeEventListener('navigateBack', this.navigateBack);
    }

    navigateBack = (e: CustomEvent<{ breadcrumbUrl: string }>): void => {
        const { goBack, push } = this.props;
        const url = e?.detail?.breadcrumbUrl;
        console.log('customevent');
        url ? push(url) : goBack();
        // goBack();
    };

    public render(): JSX.Element {
        return (
            <>
                {/* {this.state.isLoading && <Loader />} */}
                <iframe
                    ref={this.iFrameRef}
                    referrerPolicy="unsafe-url"
                    title="legacyDash"
                    srcDoc={this.template}
                    style={{
                        border: 'none',
                        height: '100vh',
                        display: 'block',
                    }}
                    width={'100%'}
                    sandbox="allow-scripts allow-top-navigation allow-top-navigation-by-user-activation allow-forms allow-popups allow-same-origin"
                />
            </>
        );
    }
}

export default compose(
    withTranslation(),
    connect<LegacyDashRouteType, DispatchProps>(mapState, dispatchProps)
)(LegacyDashRoute);
